/**
 * 전략 신호 유틸리티
 */
import type { StrategySignals } from '../types/watchlist';
import type { Signal } from '../types/strategy';

type StrategyDetail = {
  signal?: number;
  strength?: number;
  weight?: number;
  weighted?: number;
};

function toNormalizedSignal(detail: StrategyDetail | undefined): StrategySignals['MA'] {
  if (!detail) {
    return { signal: 0, strength: 0 };
  }

  const rawSignal = Number(detail.signal ?? 0);
  const normalizedSignal = rawSignal > 0 ? 1 : rawSignal < 0 ? -1 : 0;

  if (typeof detail.strength === 'number') {
    const boundedStrength = Math.max(0, Math.min(1, detail.strength));
    return {
      signal: normalizedSignal,
      strength: Number(boundedStrength.toFixed(2)),
    };
  }

  const weight = Math.abs(Number(detail.weight ?? 1)) || 1;
  const weighted = Math.abs(Number(detail.weighted ?? rawSignal * weight));
  const ratio = weight === 0 ? 0 : Math.min(weighted / weight, 1);

  return {
    signal: normalizedSignal,
    strength: Number(ratio.toFixed(2)),
  };
}

export function mapStrategySignalResponse(signal: Signal): StrategySignals {
  const { details } = signal;

  return {
    MA: toNormalizedSignal(details?.MA),
    RSI: toNormalizedSignal(details?.RSI),
    MACD: toNormalizedSignal(details?.MACD),
    BB: toNormalizedSignal(details?.BB),
    VOL: toNormalizedSignal(details?.VOL),
    SR: toNormalizedSignal(details?.SR),
    PATTERN: toNormalizedSignal(details?.PATTERN),
    combined_action: signal.action,
  };
}
